import '../../domPolyfills/classList';
import '../../domPolyfills/closest';
import './toggleClass.scss';

export function toggleClass(targetSelector, classToToggle, children) {
  const element =
    (children && children.closest
      ? children.closest(targetSelector)
      : document.querySelector(targetSelector)) || null;

  if (element && element.classList) {
    element.classList.toggle(classToToggle);
  }

  return element;
}
